import { RESET_NEW_MESSAGE, UPDATE_MESSAGE_VALUES } from './types';

const initialState = {
  newMessage: {
    type: '',
    name: '',
    sendFrom: 0,
    message: '',
    msg_send_shortcode: null,
  },
};

export default (state = initialState, action) => {
  const { type, payload, meta } = action;
  switch (type) {
    case UPDATE_MESSAGE_VALUES: {
      return {
        ...state,
        newMessage: {
          ...state.newMessage,
          ...payload,
        },
      };
    }
    case RESET_NEW_MESSAGE: {
      return {
        ...state,
        newMessage: { ...initialState.newMessage },
      };
    }
    default:
      return state;
  }
};
